import { Actions } from 'vuex-smart-module';
import { FiltersPagination } from '@/types';
import { HistroyCartsFilters } from '@/modules/cart/types';
import CartHistoryGetters from './getters';
import CartHistoryMutations from './mutations';
import CartHistoryState from './state';
import { CartService } from '../../../services';

const cartService = new CartService();

export default class CartHistoryActions extends Actions<
  CartHistoryState,
  CartHistoryGetters,
  CartHistoryMutations,
  CartHistoryActions
> {
  async get_history_items() {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;
      const payload: FiltersPagination<HistroyCartsFilters> = {
        filters: this.state.filters,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING_HISTORY(true);
      const { data, meta } = await cartService.get_history_carts(payload);

      this.mutations.SET_CART_HISTORY_ITEMS(data.items);
      this.mutations.SET_CART_HISTORY_ORGANIZATION(data.organizations);
      this.mutations.SET_CART_HISTORY_DATES(data.dates);
      this.mutations.SET_USERS(data.users);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.TOGGLE_LOADING_HISTORY(false);
    }
  }
}
